/**
 * Query string serialisation for the API instance (`paramsSerializer` in `http.ts`).
 *
 * Differences from axios 0.24's default serialiser:
 *  - `undefined`, `null` and `""` are omitted, so a page can pass an empty search box or an unset filter straight
 *    through and the server sees no parameter (`false` and `0` are kept).
 *  - arrays repeat the key (`ids=1&ids=2`), which Spring binds to a `List`; axios would send `ids[]=1&ids[]=2`.
 *  - a `Date` becomes its ISO-8601 string.
 *
 * Values are encoded with `URLSearchParams`, so `#1234` is sent as `%231234`, `+` as `%2B` and a space as `+`
 * (Spring decodes all three correctly).
 */
export function serializeParams(params: Record<string, unknown> | undefined | null): string {
    const search = new URLSearchParams();

    Object.entries(params ?? {}).forEach(([key, value]) => {
        (Array.isArray(value) ? value : [value]).forEach(item => {
            if (item === undefined || item === null || item === "") {
                return;
            }

            search.append(key, item instanceof Date ? item.toISOString() : String(item));
        });
    });

    return search.toString();
}
